// removed by extract-text-webpack-plugin
module.exports = {"miniCart__badge":"MiniCart-module__miniCart__badge___20LLp","miniCart__icon":"MiniCart-module__miniCart__icon___ytOOh"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/MiniCart/MiniCart.module.css
// module id = 633
// module chunks = 0